import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import ApiData from "../../api/ApiData";
import { SiteModalToolbarBtn } from "./SiteModalToolbarBtn";
import { SiteModalHeader } from "../UI/SiteModalHeader";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";

export const ManagerPicker = observer(({ onSelect, onClose }) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadEmployees = async () => {
      if (!ApiData.employees_dates?.length) {
        setLoading(true);
        await ApiData.getDataEmployees(true);
        setLoading(false);
      }
    };
    loadEmployees();
  }, []);

  const filteredUsers = useMemo(() => {
    const query = search.trim().toLowerCase();
    const active = (ApiData.employees_dates || []).filter((user) => user.is_active);
    if (!query) {
      return active;
    }
    return active.filter((user) => {
      const roleName = user.role_rel?.role_name?.toLowerCase() || "";
      return (
        (user.last_name || "").toLowerCase().includes(query) ||
        (user.first_name || "").toLowerCase().includes(query) ||
        roleName.includes(query)
      );
    });
  }, [search, ApiData.employees_dates]);

  const handleSelect = (user) => {
    onSelect?.(user);
    onClose?.();
  };

  return (
    <div className="manager-picker-panel" role="dialog" aria-label="Выбор менеджера">
      <SiteModalHeader
        title="Выбор менеджера"
        toolbarWrap={false}
        toolbar={
          <SiteModalToolbarBtn variant="close" onClick={onClose} title="Закрыть" />
        }
      />

      <div className="manager-picker-search-wrap">
        <input
          type="search"
          className="site-form-control manager-picker-search"
          placeholder="Поиск по фамилии, имени или роли"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
        />
      </div>

      <div className="manager-picker-list">
        <div className="manager-picker-row manager-picker-row--head">
          <span>Фамилия</span>
          <span>Имя</span>
          <span>Роль</span>
          <span className="manager-picker-col-action">Выбрать</span>
        </div>

        {loading ? (
          <p className="manager-picker-empty">Загрузка…</p>
        ) : filteredUsers.length === 0 ? (
          <p className="manager-picker-empty">Сотрудники не найдены</p>
        ) : (
          filteredUsers.map((user) => (
            <div className="manager-picker-row" key={user.id}>
              <span>{user.last_name || "—"}</span>
              <span>{user.first_name || "—"}</span>
              <span>{user.role_rel?.role_name || "—"}</span>
              <span className="manager-picker-col-action">
                <BtnOutlineV4
                  className="manager-picker-select-btn"
                  text="Выбрать"
                  onClick={() => handleSelect(user)}
                />
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
});
